//import {i18n} from '@/plugins/i18n';
import * as XLSX from 'xlsx';
import TimeStamp from "@/services/timeStamp";
// Version 1.0 2022-03-17

export default class EXCEL_DOWNLOAD{

    static exportJsonToSingleSheet(jsonList, sheetName, fileTimeStamp, config) {
        console.log ("jsonList", jsonList);
        if ( config ) { jsonList = EXCEL_DOWNLOAD.formatJsonList(jsonList, config) }
        EXCEL_DOWNLOAD.downloadToExcelSingleSheet(jsonList, sheetName, fileTimeStamp, config)

    }

    static downloadToExcelSingleSheet (jsonList, sheetName, fileTimeStamp, config) {
        let ws = XLSX.utils.json_to_sheet(jsonList);
    // set customer header if config provided
        if ( config && config.length > 0 ) {
            ws = EXCEL_DOWNLOAD.setCustomHeader(ws, config)
        }
    // add worksheet to workbook
        let wb = XLSX.utils.book_new();
        let cleanSheetName = EXCEL_DOWNLOAD.cleanSheetName(sheetName);
        XLSX.utils.book_append_sheet(wb, ws, 'Download');
        const timeStamp = fileTimeStamp ? fileTimeStamp : TimeStamp.getFileTimeStamp();
        let exportFileName = cleanSheetName + '_' + timeStamp + '.xlsx';
        XLSX.writeFile(wb, exportFileName);
    }
        static formatJsonList(jsonList, config){
            return jsonList.map(row => {
                const newRow = {};
                config.forEach((configItem) => {
                    if ( configItem.childOf && row[configItem.childOf] ) {
                        newRow[configItem.value] = row[configItem.childOf][configItem.value]
                    } else {
                        newRow[configItem.value] = row[configItem.value]
                    }
                    if ( configItem.type ==='tsToDate' ) {
                        /*let options = { year: 'numeric', month: 'numeric', day: 'numeric',
                            hour: 'numeric', minute: 'numeric'};
                        let dateFormated = new Date(newRow[configItem.value]);
                        newRow[configItem.value] = dateFormated.toLocaleDateString(i18n.locale, options);*/
                        newRow[configItem.value] = TimeStamp.getLocalStringFromGMTts(newRow[configItem.value]);
                    }
                });
                return newRow;
            });
        }
        static setCustomHeader(ws, config){
            let i = 0;
            let range = XLSX.utils.decode_range(ws['!ref']);
            for(let C = range.s.c; C <= range.e.c; ++C) {
                let address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
                if(!ws[address]) continue;
                ws[address].v = config[i].text//ws[address].v.toUpperCase();
                i++;
            }
            return ws;
        }

        static cleanSheetName(sheetName){
            sheetName = sheetName.replaceAll('/', '_');
            sheetName = sheetName.replaceAll('\\', '_');
            sheetName = sheetName.replaceAll('?', '_');
            sheetName = sheetName.replaceAll('*', '_');
            sheetName = sheetName.replaceAll('[', '_');
            sheetName = sheetName.replaceAll(']', '_');
            return sheetName;
        }

}